<template>

	<button class="edu-button base-rounded mt-3" @click="goToLoginPage()">
		<v-row align="center" justify="center">
			<v-col cols="2" class="d-flex justify-center">
				<v-img src="/assets/logo-edu.png" max-height="45" max-width="45" class="mr-2"/>
			</v-col>
			<v-col cols="9" class="d-flex justify-center align-center font-weight-medium text">
				<div>{{ $t('ministryOfEducationLogin') }}</div>
			</v-col>
		</v-row>

	</button>

</template>

<script>
export default {
	name: "EduLoginButton",
	methods: {
		async goToLoginPage() {
			// save current project here
			let redirect = "/login/education";
			if (this.$route.query.p) {
				sessionStorage.setItem("activeProject", this.$route.query.p);
				redirect += `?p=${this.$route.query.p}`;
			}
			window.location = redirect;
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../sass/generic";

.edu-button {
	height: 55px;
	width: 100%;
	background-color: $grey-backround;
	border: 1px solid grey;
	font-size: 1.6rem;

	.text {
		color: $black-text;
	}
}
</style>
